module.exports = __webpack_public_path__ + "img/Backyard-paws-Cover.4d6c4d97.webp";